import { getAuthHeaders } from '../lib/authHeaders';
import type { WarRoomConsensus } from '../types/warRoom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Fetch the War Room consensus doc for a report.
 *
 * GET /api/v1/war-room/consensus/{reportId} is dual-auth (Clerk / accountant-JWT /
 * attorney-JWT) and role-filtered server-side (privileged rationale scrubbed for
 * CPA-equivalent roles). Returns null on 404 (no consensus recorded yet); other
 * errors throw for the caller to surface.
 */
export async function getWarRoomConsensus(reportId: string): Promise<WarRoomConsensus | null> {
  const headers = await getAuthHeaders();
  const response = await fetch(`${BACKEND_URL}/api/v1/war-room/consensus/${reportId}`, { headers });
  if (response.status === 404) return null;
  if (!response.ok) {
    throw new Error(`Failed to fetch consensus: ${response.statusText}`);
  }
  return response.json();
}
